import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    this.element.addEventListener("turbo:frame-load", this.handleFrameLoad)
    this.scrollToTop()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.handleFrameLoad)
  }

  handleFrameLoad() {
    this.scrollToTop()
  }

  scrollToTop() {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: "smooth" })
    })
  }
}
